"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleFilter = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ProgressiveImage_1 = __importDefault(require("../Other/ProgressiveImage"));
const useFetchSvg_1 = __importDefault(require("../../helpers/Hooks/useFetchSvg"));
const BubbleFilterList = styled_components_1.default.ul `
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 10px 0;

  @media (min-width: 600px) {
    margin: 0 32px;
  }

  @media (min-width: 1240px) {
    margin: 0 200px;
  }
`;
const BubbleFilterListItem = styled_components_1.default.li `
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 70px;
  gap: 5px;
  min-width: 70px;
  cursor: pointer;

  .filter-name {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;

  }

  .interest-filter-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    min-height: 45px;
    min-width: 45px;
    background-color: ${(props) => {
    const backupColor = "#d8d8d8";
    if (!props.theme.palette) {
        return backupColor;
    }
    const filterIsActive = props.currentFilter.id === props.selectedFilter.id;
    if (!filterIsActive && props.theme.palette.mainAppColor.dark === props.theme.palette.mainAppColor.light) {
        return backupColor;
    }
    const color = filterIsActive ? props.theme.palette.mainAppColor.dark : props.theme.palette.mainAppColor.light;
    return color;
}};
  }
`;
const BubbleFilterIconWrapper = styled_components_1.default.div `
  img {
    width: 50%;
    height: 50%;
  }
`;
const SvgWrapper = styled_components_1.default.div `
  .svg-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    height: 100%;
    width: 100%;

    [fill-rule~='nonzero'] {
      /* eslint-disable prefer-destructuring */
      fill: ${(props) => {
    const filterIsActive = props.currentFilter.id === props.selectedFilter.id;
    const color = filterIsActive ? '#FFF' : '#000';
    return color;
    /* eslint-disable prefer-destructuring */
}};
    }
  }
`;
const BubbleFilter = (props) => {
    const { theme, selectedFilter, filterActivitiesByInterest, filters } = props;
    const handleFilterClick = (filter) => {
        filterActivitiesByInterest(filter);
    };
    const bubbleFilters = filters.filter((filter) => filter.interests.length > 0);
    if (bubbleFilters.length < 1) {
        return null;
    }
    return (react_1.default.createElement(BubbleFilterList, { "data-testid": "bubble-filter-list", className: `interest-filter-list ${bubbleFilters.length < 5 ? 'align-center' : ''}` }, bubbleFilters.map((filter, index) => {
        const iconUrl = filter.iconUrl;
        let loadedSvg = null;
        // images can be SVG or PNG, we only want to fetch the svgs that are not user uploads
        if (filter.iconUrl && filter.iconUrl.includes('.svg') && !filter.iconUrl.includes('/uploads')) {
            loadedSvg = (0, useFetchSvg_1.default)(iconUrl);
        }
        return (react_1.default.createElement(BubbleFilterListItem, { key: (0, react_uid_1.uid)(filter), role: "presentation", className: "center interest-filter", "data-testid": "interest-filter", onClick: () => handleFilterClick(filter), id: `aqa_interest_filter_${index}`, theme: theme, currentFilter: filter, selectedFilter: selectedFilter },
            loadedSvg ? (react_1.default.createElement(SvgWrapper, { className: "interest-filter-icon", currentFilter: filter, selectedFilter: selectedFilter },
                react_1.default.createElement("div", { className: "svg-container", dangerouslySetInnerHTML: {
                        __html: loadedSvg,
                    } }))) : (react_1.default.createElement(BubbleFilterIconWrapper, { className: "interest-filter-icon" }, iconUrl && (react_1.default.createElement(ProgressiveImage_1.default, { image: filter.iconUrl, indexOfImage: index, alt: `${filter.name} icon`, imageClass: `bubble-filter-image-${index}` })))),
            react_1.default.createElement(Typography_1.default, { className: "filter-name", variant: "caption" },
                " ",
                filter.name,
                " ")));
    })));
};
exports.BubbleFilter = BubbleFilter;
